<template>
  <div style="display:grid; min-height:100vh;">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <green-nav />
    <div class="row" style="margin-top: 5.4rem">
      <div class="col-md-5 backImage d-none d-sm-block"></div>
      <div class="col-md-7">
        <div class="container">
          <h2 class="text-green font-weight-bold mt-md-5">
            Contact Us
          </h2>
          <p class="mb-4">
            Fill out the application form to apply for our scholarship available
            for lactating mothers
          </p>
          <form class="" @submit.prevent="submitContactForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">
                    Full Name
                  </label>
                  <input
                    id="name"
                    required
                    v-model="full_name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email_address">
                    Email Address
                  </label>
                  <input
                    id="email_address"
                    required
                    v-model="email_address"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="why_join">
                    Message
                  </label>
                  <textarea
                    id="why_join"
                    required
                    v-model="message"
                    style="resize: vertical"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-12 text-right mt-5">
                <button class="btn btn-orange pl-5 pr-5" type="submit">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import axios from "axios";
import GreenNav from "../components/navbar_green";
import downFooter from "../components/footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";


export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      full_name: "",
      email_address: "",
      message: "",
      height: 128,
      width: 128
    };
  },
  components: {
    Loading,
    downFooter,
    GreenNav
  },

  methods: {
    submitContactForm() {
      this.isLoading = true;
      axios
        .post(
          `http://gtl-notification-service.us-east-2.elasticbeanstalk.com/api/v0/notify`,
          {
            recipients: ["ladiesintech@ghanatechlab.com"],
            type: "email",
            message: `<div class="card"><div class="card-body"><h3>Contact Information</h3><hr><div class="font-italic" style="margin-bottom: 1rem">Full name : ${this.full_name}</div><div class="font-italic" style="margin-bottom: 1rem">Email Address : ${this.email_address}</div><div class="font-italic" style="margin-bottom: 1rem">Message : ${this.message}</div></div></div>`,
            subject: "Ghana Ladies In Tech Contact Form"
          }
        )
        .then(() => {
          this.full_name = "";
          this.email_address = "";
          this.message = "";
          Swal.fire({
            title: "Success!",
            text: "Contact message has been sent successfully...",
            icon: "success",
            confirmButtonText: "ok"
          });
        }).catch(()=>{
        Swal.fire({
          title: "Error!",
          text: "Error whiles sending the contact information...",
          icon: "error",
          confirmButtonText: "ok"
        });
      })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted: function() {},
  created() {}
};
</script>

<style scoped>
.backImage {
  background: url("../../public/assets/img/contact_us.png") no-repeat center;
  background-size: cover;
  background-position-y: center;
}
label {
  color: #444;
}

.form-control {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  margin-top: 0.5rem !important;
}
textarea {
  min-height: 7rem;
}

.form-control:invalid {
  background-image: none !important;
}
</style>
